import { useEffect, useState } from 'react';

import type { MyOrderFragment } from '@/graphql/saleor/api';
import { generatePayPerLinkToken } from '@/views/ReviewView/helpers';

export const usePaymentToken = (order?: MyOrderFragment) => {
  const orderStatus = order?.orderStatus;
  const [token, setToken] = useState<string>();
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    if (order) {
      (async () => {
        if (orderStatus === 'PENDING' || orderStatus === 'PARTIALLY_PAID') {
          const nowTime = Date.now() / 1000;
          const payPerLinkToken = order?.payPerLinkToken;
          const expireTime = order?.payPerLinkExpiration;

          if (!payPerLinkToken || !expireTime || nowTime > +expireTime) {
            setLoading(true);
            const data = await generatePayPerLinkToken(order.id);
            setLoading(false);
            setToken(data);
          } else {
            setToken(payPerLinkToken);
          }
        }
      })();
    }
  }, [order]);

  return { payPerLinkToken: token, isPayPerLinkTokenLoading: loading };
};
